var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnblock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39.99999999999999,
    height: 39.99999999999999,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "&gt;\n ", _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_2",
    fill: "#DB0716",
    d: "m5.90565,34.1449c7.78409,7.78405 20.40449,7.78405 28.18876,0c7.78405,-7.78427 7.78405,-20.40467 0,-28.18876c-7.78427,-7.78409 -20.40467,-7.78409 -28.18876,0c-7.78409,7.78409 -7.78409,20.40449 0,28.18876zm4.80914,-1.6772c6.07232,4.55256 14.72497,4.06754 20.24736,-1.45507c5.5226,-5.52238 6.00763,-14.17504 1.45507,-20.24736l-6.15313,6.15315c-0.86484,0.86484 -2.2672,0.86484 -3.13204,0c-0.86484,-0.86484 -0.86484,-2.2672 0,-3.13211l6.15313,-6.15313c-6.0723,-4.55256 -14.72486,-4.06756 -20.24745,1.45502c-5.52258,5.52258 -6.00758,14.17515 -1.45502,20.24745l6.15313,-6.15313c0.86491,-0.86484 2.26727,-0.86484 3.13211,0c0.86484,0.86484 0.86484,2.2672 0,3.13204l-6.15315,6.15313z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnblock);
export default __webpack_public_path__ + "static/media/unblock.e708177beb9fb8c12a4bfe4bd35e0fa5.svg";
export { ForwardRef as ReactComponent };